// main.js

import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store'; // Import the store
import i18n from './i18n';

// Import Bootstrap JS (includes Popper.js)
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

// Import Custom Bootstrap SCSS
import './assets/custom-bootstrap.scss';

// Optionally import Bootstrap Icons CSS
import 'bootstrap-icons/font/bootstrap-icons.css';

// Import Custom CSS
import './assets/style.css';

import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';

const app = createApp(App)
    .use(router)
    .use(store) // Use the store
    .use(i18n); // Use i18n

app.component('VueDatePicker', VueDatePicker);
app.mount('#app');
